import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/resource/images/icon_favicon.png'


const _withScopeId = n => (_pushScopeId("data-v-02dc88c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "titleWrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "fl",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", {
      class: "fl",
      style: {},
      innerHTML: _ctx.title
    }, null, 8, _hoisted_3)
  ]))
}